/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /*-------------------------
      UNIQUE CUSTOM JS
 --------------------------*/

/* -------------------*/
/* LANGUAGES DROPDOWN */
/* -------------------*/

$('[data-dropdown-handle]').unbind('click');

$('[data-dropdown-handle]').on('click', function(e) {
  e.preventDefault();

  if ($(this).closest('[data-dropdown]').attr('data-dropdown') === 'opened') {
    $(this).closest('[data-dropdown]').attr('data-dropdown', '');
  } else {
    if ($(this).closest('[data-dropdown-group]').length > 0) {
      $(this).closest('[data-dropdown-group]').find('[data-dropdown]').attr('data-dropdown', '');
    }

    $(this).closest('[data-dropdown]').attr('data-dropdown', 'opened');
  }
});

/* --------------------*/
/* PRODUCT LINK TO B2B */
/* --------------------*/

let productHandle = $('[data-product-handle]').attr('data-product-handle');
let rootUrl = $('[data-external-url]').attr('data-external-url');
let lastChar;
let char = '';

if(rootUrl) {
  let lastChar = rootUrl.slice(-1);
}

if(lastChar !== '/') {
  char = '/';
}

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant;
  $('.unique-b2b-link').attr('href', rootUrl + char + 'products/' + productHandle + '?variant=' + variant.id);
});

/* ---------------------------------*/
/* SCROLLTOP WHEN SUBMIT NEWSLETTER */
/* ---------------------------------*/

setTimeout(function () {
  if($('.shopify-challenge__container').length) {
    $('html, body').animate({scrollTop:0}, 500);
  }
}, 1000);

/* ----------------*/
/* PRODUCT GALLERY */
/* ----------------*/

// Switch galleries when variant changes

if($('body').hasClass('template-product')) {
  $('[data-option-handle]').on('click', function(event) {
    $('.unique-product-gallery-wrapper').removeClass('is-selected');

    let targetOption = $(this).attr('data-option-handle');
    let gallery = $('.unique-product-gallery-wrapper[data-gallery-handle="'+ targetOption +'"]');

    gallery.addClass('is-selected');
  });
}

// Swiper

$('.unique-product-gallery').each(function(index, element){
  let $this = $(this);
  $this.addClass('instance-' + index);
  //let thumbs = $('.unique-gallery-thumbnails.instance-' + index);
  let swiper = new Swiper('.instance-' + index, {
    direction: 'vertical',
    zoom: true,
    mousewheel: true,
    freeMode: true,
    freeModeSticky: true,

    on: {
      init: function() {
        let container = $('.swiper-container.instance-'+index).closest('.unique-product-gallery-wrapper');
        let activeSlidePos = $(this)[0].activeIndex;
        container.find('.unique-gallery-thumbnail').eq(activeSlidePos).addClass('is-selected');
      },

      slideChange: function() {
        $('.unique-gallery-thumbnail').removeClass('is-selected');

        let container = $('.swiper-container.instance-'+index).closest('.unique-product-gallery-wrapper');
        let activeSlidePos = $(this)[0].activeIndex;
        container.find('.unique-gallery-thumbnail').eq(activeSlidePos).addClass('is-selected');
      }
    }
  });

  $(this).closest('.unique-product-gallery-wrapper').find('.unique-gallery-thumbnails [data-media-position]').on('click', function() {
    swiper.slideTo($(this).index());
  });

  $('.ProductForm__Option .HorizontalList__Item').on('click', function() {
    swiper.update();

    let container = $('.swiper-container.instance-'+index).closest('.unique-product-gallery-wrapper');
    let activeSlidePos = swiper.activeIndex;
    container.find('.unique-gallery-thumbnail').eq(activeSlidePos).addClass('is-selected');
  });
});

$('.unique-fancybox-trigger').fancybox({
  backFocus: false,
  loop: false,
  thumbs: {
    autoStart: true,
    parentEl: ".fancybox-container",
    axis: "x"
  },
  buttons: [
    //"zoom",
    //"share",
    "slideShow",
    //"fullScreen",
    //"download",
    "thumbs",
    "close"
  ]
});

// Geoloc API

$.ajax({
  typ: 'GET',
  url: 'https://api.symback.unique.paris/geoip/country',
  dataType: 'json',
  success: function(data) {
    let geoipCountry = data.geoip_country;
    let containerProduct = $('[data-section-type="product"]');
    let containerTeaser = $('.ProductItem');

    localStorage.setItem(theme.shopName + '_geoip', geoipCountry);

    if (localStorage.getItem(theme.shopName + '_geoip') !== null && localStorage.getItem(theme.shopName + '_geoip') !== 'FR' && theme.siteMode === 'b2c') {
      $('body').addClass('unique-ecommerce-disabled');

      $('.ProductMeta__PriceList, .ProductItem__PriceList').each(function() {
        $(this).html('');
      });
    }
  },
  error: function(jqxhr, textStatus, error) {
    let err = textStatus + ", " + error;
    console.log( "Request Failed: " + err );
  }
});

/* ------------------ */
/* HIDE PRICES BUTTON */
/* ------------------ */

if (theme.siteMode === 'b2b') {
  $('[data-visible-price]').on('click', function(e) {
    localStorage.setItem(theme.shopName + '_visibleprice', $(this).attr('data-visible-price'));

    if (localStorage.getItem(theme.shopName + '_visibleprice') === 'visible') {
      $(this).removeAttr('data-visible-price')
      $(this).attr('data-visible-price', 'hidden');

      $('body').removeClass('unique-visible-prices');

      localStorage.setItem(theme.shopName + '_visibleprice', $(this).attr('data-visible-price'));
    } else {
      $(this).removeAttr('data-visible-price')
      $(this).attr('data-visible-price', 'visible');

      $('body').addClass('unique-visible-prices');

      localStorage.setItem(theme.shopName + '_visibleprice', $(this).attr('data-visible-price'));
    }
  });

  if (localStorage.getItem(theme.shopName + '_visibleprice') === 'hidden' || localStorage.getItem(theme.shopName + '_visibleprice') === null) {
    $('[data-visible-price]').attr('data-visible-price', 'hidden');

    $('body').removeClass('unique-visible-prices');
  } else {
    $('[data-visible-price]').attr('data-visible-price', 'visible');

    $('body').addClass('unique-visible-prices');
  }
} else {
    localStorage.setItem(theme.shopName + '_visibleprice', 'visible');
}


    /* TRANSLATIONS */
    $('.titletext').html(window.i18n.wishlist['title']);
    $('.sharebutton').html(window.i18n.wishlist['share']);
    $('.clearall').html(window.i18n.wishlist['clear_all']);
    $('.product .addsingleproduct').html(window.i18n.wishlist['add_to_cart']);
    $('.product .removebutton').html(window.i18n.wishlist['remove']);

    // Show header with text and button on content loaded
    $('#heading-breadcrumbs').addClass('show-title-wishlist');



  /* --------------- */
  /* AIR DATE PICKER */
  /* --------------- */
if (theme.siteMode === 'b2b') {
  $('body').on('click', '[data-datepicker]', function(e) {
    let datePicker = $('[data-datepicker]').datepicker({
      language: theme.shopLocale,
      minDate: new Date(),
      autoClose: true,
      position: 'top left',
      dateFormat: 'dd / mm / yyyy',
      altField: '#Cart__Shipping-date',
      altFieldDateFormat: 'yyyy-mm-dd',

      onSelect: function(fd, date, inst) {
        $('.Cart__Date').html(window.languages.shippingChosenDate + fd);
        $('.Cart__Datepicker').val(window.languages.shippingDateChange);

        if(fd === '') {
          $('.Cart__Date').html('');
          $('.Cart__Datepicker').val(window.languages.shippingDateDefine);
        }
      },
      onShow: function(inst, animationCompleted) {
        if ($('#Cart__Shipping-date').val() === '') {
          $('.Cart__Date').html('');
          $('.Cart__Datepicker').val(window.languages.shippingDateDefine);
        }else {
          $('.Cart__Datepicker').val(window.languages.shippingDateChange);
        }
      }
    }).data('datepicker');

    datePicker.show();
  });
}

/* --------------------- */
/*   DATE AVAILABILITY   */
/* --------------------- */

if (theme.siteMode === 'b2b') {
  document.addEventListener('variant:changed', function (event) {
      let variant = event.detail.variant;
      $('[data-product-date-available]').html('');

      if (variant !== null && $('[data-product-' + variant.id + '-available-date]').length) {
          let availabilityDate = $('[data-product-' + variant.id + '-available-date]').attr('data-product-' + variant.id + '-available-date');
          $('[data-product-date-available]').html(availabilityDate);

      }

      if ($('[data-hide-add-to-cart]').length) {
          $('.ProductForm__AddToCart').replaceWith('<input type="hidden" class="ProductForm__AddToCart"/>')
      }
  });
}

/* --------------- */
/*   CART CLEAR    */
/* --------------- */
if (theme.siteMode === 'b2b') {
  $('.Form__Submit--login').on('click', function(e) {
    jQuery.post('/cart/clear.js');
  });
}


/* --------------- */
/*      LOGIN      */
/* --------------- */
if (theme.siteMode === 'b2b') {
  $('#customer_login [data-action="toggle-recover-form"]').on('click', function(e) {
    $('#recover_customer_password').removeClass('unique-hidden');
    $('#customer_login').addClass('unique-hidden');
  });

  $('#recover_customer_password [data-action="toggle-recover-form"]').on('click', function(e) {
    $('#customer_login').removeClass('unique-hidden');
    $('#recover_customer_password').addClass('unique-hidden');
  });
}


/* --------------- */
/*      PLV        */
/* --------------- */

/*
* Le code ci-dessous permet de gérer le système de PLV offerte contre des points de fidélité.
* Pour fonctionner correctement, il faut que le produit soit configuré avec un tag "PLV".
* Le nombre de point à déduire est défini en fonction du prix du produit : 1 point = 1€.
* La gratuité est gérée par une règle de discount automatique sur la collection qui contient le produit.
* * */


if (theme.siteMode === 'b2b' && Shopify.Customer !== undefined && Shopify.activeVariant !== undefined) {

  if (Shopify.isPLV) {
      //Au click sur le bouton "Ajouter au panier"
      $('[data-action="add-to-cart"]').click((e) => {

              //Si le produit est un PLV, on intercepte le click et on vérifie le solde fidélité du client
              let quantity = parseInt($('[name="quantity"]').val())
              let price = (Shopify.activeVariant.price / 100) * quantity

              let fidelityAmount = Shopify.Customer.fidelity_amount
              // console.table({price, fidelityAmount})

              if (price > Shopify.Customer.fidelity_amount) {
                  
                  e.preventDefault();
                  
                  //Si le solde fidélité est insuffisant, on affiche un message d'erreur

                  //Si le bouton est déjà en erreur, je retourne false directement.
                  let addToCartButton = document.querySelector('.ProductForm__AddToCart');
                  if (addToCartButton.classList.contains('errored')) {
                      return false;
                  }

                  let errorMessageElement = document.createElement('span');
                  errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                  errorMessageElement.innerHTML =  Shopify.Customer.fidelity_error_message;
                  document.querySelector('.ProductForm__Variants').insertAdjacentElement('afterend', errorMessageElement);
                  addToCartButton.classList.add('errored');

                  setTimeout(function () {
                      errorMessageElement.remove();
                      addToCartButton.classList.remove('errored');
                  }, 2500);

                  return false
              } else {
                  return true
              }
          }
      )

      //Quand une variante change je mets à jour le bouton "Ajouter au panier" en fonction du solde fidelité du client et du prix de la variante.
      $(document).on('variant:changed', function (e) {
          Shopify.activeVariant = e.originalEvent.detail.variant
          let quantity = parseInt($('[name="quantity"]').val())
          updateAddToCartForFidelity(Shopify.activeVariant.price / 100, quantity, Shopify.Customer.fidelity_amount)
      })

      //Bouton d'augmentation de la quantité sur la fiche produit
      $('[data-action="decrease-quantity"], [data-action="increase-quantity"]').click(() => {
          // We use a timeout to requeue the function after the quantity has been updated.
          // That's a bit dirty, but if we not do that, that cause problem with the quantity input.
          // See this StackOverflow answer for more details : https://stackoverflow.com/questions/5756911/binding-event-in-jquery-to-be-executed-always-in-the-end

          setTimeout(() => {
              let quantity = parseInt($('[name="quantity"]').val())
              updateAddToCartForFidelity(Shopify.activeVariant.price / 100, quantity, Shopify.Customer.fidelity_amount)
          })
      })

      //Input de quantité de la fiche produit
      $('[name="quantity"]').change(() => {
          let quantity = parseInt($('[name="quantity"]').val())
          updateAddToCartForFidelity(Shopify.activeVariant.price / 100, quantity, Shopify.Customer.fidelity_amount)
      })
  }
}

function canUpdatePLVQuantity(price, quantity, fidelity_amount) {
  price = parseInt(price) / 100;
  return (price * quantity <= fidelity_amount)
}

function updateFidelityAmount(){
  let fidelity_amount = 0;

  if (Shopify.Customer !== undefined) {

      fidelity_amount = Shopify.Customer.fidelity_amount_initial

      fetch("/cart.json").then((response) => {
          response.json().then((cart) =>{
              cart.items.forEach((item) => {
                  item.discounts.forEach((discount) => {
                      if (discount.title === "myMorel"){
                          fidelity_amount = fidelity_amount - (discount.amount / 100)
                      }
                  })
              })

              $('#fidelity-amount').text(fidelity_amount + " point" + (fidelity_amount > 1 ? "s" : ""))
              //$('.Header__fidelity').addClass("initialized");

              Shopify.Customer.fidelity_amount = fidelity_amount

          });
      })
  }

}

function updateAddToCartForFidelity(price, quantity, fidelity_amount) {

  // console.table({price, quantity, fidelity_amount})

  if (price * quantity > fidelity_amount) {
      //Le client n'a pas assez de points de fidélité pour bénéficier de la gratuité
      $('[data-action="add-to-cart"]').removeClass("Button--primary").addClass(["Button--secondary", "disabled"])
  } else {
      //Le client a assez de points de fidélité pour bénéficier de la gratuité
      $('[data-action="add-to-cart"]').removeClass(["Button--secondary", "disabled"]).addClass("Button--primary")
  }

}

window.canUpdatePLVQuantity = canUpdatePLVQuantity;
window.updateFidelityAmount = updateFidelityAmount;


/* ---------------------------------------- */
/*      Primary color on product page       */
/* ---------------------------------------- */

document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant;
    var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
    console.log("______ COLOR : ");
    console.log(jsonData.metafields_variants[variant.id].mymorel.color_name);
    let primaryColor = jsonData.metafields_variants[variant.id].mymorel.color_name;
    let primaryColorElement = document.querySelector('.Product__PrimaryColor');

    if (primaryColorElement !== null) {
        primaryColorElement.innerHTML = "(" + primaryColor + ")";
    }
    else{
      primaryColorElement.innerHTML = "";
    }
});